/**
 * src/components/Financial/Modules/IngressModule.jsx
 * 【完全版：星座カラー設定の強制適用 ＋ 絵文字化防止 ＋ 垂直実線化】
 */
import React from "react";
import { Check } from "lucide-react";
import { PLANET_SYMBOLS, PLANET_COLORS } from "../../../utils/constants.js";

/**
 * IngressLayer: チャート上のイングレス描画
 */
export const IngressLayer = function (props) {
  var ingresses = props.ingresses || [];
  var coords = props.coords;
  var displayRange = props.displayRange;
  var planetColors = props.planetColors || {};
  var signColors = props.signColors || {}; // 設定された星座色

  return (
    <g className="ingress-layer">
      {ingresses.map(function (ev, i) {
        // 表示範囲外のチェック
        if (typeof ev.index !== 'number') return null;
        if (
          ev.index < displayRange.start ||
          ev.index >= displayRange.start + displayRange.count
        ) {
          return null;
        }

        var xPos = coords.getX(ev.index - displayRange.start);
        var pColor = planetColors[ev.planet] || PLANET_COLORS[ev.planet] || "#64748b";
        
        // 星座記号と色の取得
        var signSymbol = (ev.toSign && ev.toSign.symbol) ? ev.toSign.symbol : "";
        // 参考コードに基づき、設定色がない場合は #8b5cf6 を適用。絵文字化防止コードを付加
        var sColor = (signSymbol && signColors[signSymbol]) ? signColors[signSymbol] : "#8b5cf6";
        var signText = signSymbol ? signSymbol + "\uFE0E" : ""; 

        return (
          <g key={"ing-" + ev.planet + "-" + i} transform={"translate(" + xPos + ", 0)"}>
            {/* 垂直の境界線：点線を廃止し、実線（solid）に変更 */}
            <line
              y1={coords.pad.t}
              y2={coords.pad.t + coords.iH}
              stroke={pColor}
              strokeWidth="1.2"
              opacity="0.5"
            />
            
            {/* アイコンブロック：惑星の下に星座を表示 */}
            <g transform={"translate(0, " + (coords.pad.t - 55) + ")"}>
              {/* 惑星アイコン */}
              <text
                fill={pColor}
                fontSize="18"
                textAnchor="middle"
                fontWeight="bold"
                style={{ fontFamily: 'sans-serif' }}
              >
                {PLANET_SYMBOLS[ev.planet]}
              </text>
              
              {/* 星座アイコン：紫背景を排除し、設定色でテキスト描画 */}
              {signText && (
                <text
                  y="22"
                  fill={sColor}
                  fontSize="17"
                  textAnchor="middle"
                  style={{ fontFamily: 'sans-serif' }}
                >
                  {signText}
                </text>
              )}
            </g>
          </g>
        );
      })}
    </g>
  );
};

/**
 * IngressSettingsUI: 設定画面のUI
 */
export const IngressSettingsUI = function (props) {
  var selectedPlanets = props.selectedPlanets;
  var setSelectedPlanets = props.setSelectedPlanets;
  var isDarkMode = props.isDarkMode;
  var planets = [
    "Sun",
    "Moon",
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  var pnlBox = {
    background: isDarkMode ? "#1e222d" : "#f8fafc",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid " + (isDarkMode ? "#374151" : "#e2e8f0"),
  };
  var pTitle = {
    fontSize: "15px",
    fontWeight: "bold",
    color: isDarkMode ? "#fff" : "#1e293b",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  var plBtnSt = function (p, active) {
    var baseColor = PLANET_COLORS[p] || "#6366f1";
    return {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: "600",
      cursor: "pointer",
      background: active ? (isDarkMode ? "#374151" : "#fff") : (isDarkMode ? "#0b0e14" : "#f1f5f9"),
      border: "1.5px solid " + (active ? baseColor : (isDarkMode ? "#374151" : "#e2e8f0")),
      color: active ? baseColor : (isDarkMode ? "#9ca3af" : "#64748b"),
    };
  };

  return (
    <div style={pnlBox}>
      <div style={pTitle}>
        <Check size={18} /> <span>サイン・イングレス設定</span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {planets.map(function (p) {
          return (
            <button
              key={p}
              onClick={function () {
                var n = new Set(selectedPlanets);
                if (n.has(p)) n.delete(p);
                else n.add(p);
                setSelectedPlanets(n);
              }}
              style={plBtnSt(p, selectedPlanets.has(p))}
            >
              <span style={{ fontSize: "14px" }}>{PLANET_SYMBOLS[p]}</span>
              <span>{p}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};